import * as DashboardActions from './dashboard.actions';

import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {createReducer, on} from '@ngrx/store';
import {StoredComponentHelperService} from '@common/helpers/stored-component.helper.service';
import {DashboardRequests, DashboardRow, DashboardSearchParams} from '@communication/_common/models/dashboard.models';
import {EntityStateModel} from '@common/models/entity-state.models';
import {SetAllInitialStates} from '@common/store/actions/core.actions';

export const dashboardFeatureKey = 'dashboard';

export interface DashboardState extends EntityStateModel<DashboardRow, DashboardSearchParams> {
    activeVotingExists: boolean,
    userRequests?: DashboardRequests[]
}

export const adapter: EntityAdapter<DashboardRow> = createEntityAdapter<DashboardRow>({});

export const initialState: DashboardState = adapter.getInitialState({
    listLoading: 'listLoading',
    pagination: {},
    itemsLoading: [],
    userRequests: [],
    activeVotingExists: false
});

export const dashboardReducer = createReducer(
    initialState,

    on(DashboardActions.CheckState, (state, action) => {
        if (action.payload.modalView) {
            return adapter.removeAll({
                ...state,
                savedFilter: !action.payload.close && state.filter ? state.filter : undefined,
                pagination: initialState.pagination,
                filter: action.payload.close ? state.savedFilter : undefined
            });
        } else {
            if (action.payload.close) {
                return adapter.setAll(action.payload.items, {
                    ...state,
                    pagination: {...state.pagination, number: 0},
                    componentOpened: false
                });
            }

            return {...state, componentOpened: true};
        }
    }),

    on(DashboardActions.LoadRequestsSuccess, (state, action) => ({
        ...state,
        userRequests: action.requests
    })),

    on(DashboardActions.LoadList, (state, action) => ({
        ...state,
        listLoading: StoredComponentHelperService.updateListLoading(action.payload, state.ids)
    })),

    on(DashboardActions.LoadListSuccess, (state, action) => {
        return action.payload.clearState
            ? adapter.setAll(action.payload.items, {
                ...state,
                pagination: action.payload.pagination,
                activeVotingExists: action.payload.activeVotingExists,
                listLoading: undefined

            })
            : adapter.upsertMany(action.payload.items, {
                ...state,
                pagination: action.payload.pagination,
                activeVotingExists: action.payload.activeVotingExists,
                listLoading: undefined
            });
    }),

    on(DashboardActions.LoadListFailure, (state) => ({...state, loading: undefined})),

    on(DashboardActions.SetFilter, (state, action) => ({
        ...state,
        filter: action.payload
    })),

    on(DashboardActions.SetPagination, (state, action) => ({
        ...state,
        pagination: {...state.pagination, number: action.payload ? StoredComponentHelperService.setNextPage(state.pagination, state.ids?.length) : 0}
    })),

    on(DashboardActions.SetLoading, (state, action) => ({
        ...state,
        listLoading: action.payload
    })),

    on(DashboardActions.SetItemsLoading, (state, action) => ({
        ...state,
        itemsLoading: StoredComponentHelperService.updateItemLoading(state.itemsLoading, action.payload.id, action.payload.isStart)
    })),

    on(DashboardActions.UpdateItemSuccess, (state, action) => {
        return (
            adapter.updateOne({id: action.payload.id, changes: action.payload}, {
                ...state,
                itemsLoading: StoredComponentHelperService.updateItemLoading(state.itemsLoading, action.payload.id, false),
            })
        );
    }),

    on(DashboardActions.SetInitialState, SetAllInitialStates, () => ({...initialState})),
);

export const {selectAll: selectAllEntities} = adapter.getSelectors();
